// Connects the Edit patient info modal component with store

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import EditPatient from '../../components/modal/EditPatient';
import { getDocumentCategories } from '../../actions/userProfile';
import {
  editReceivedRecordLabels,
  reportEmailAttachmentPatientUpdateError,
  updateEmailAttachmentPatientInfo,
  updatePatientInfo,
  updateSelectedRecordLabels,
} from '../../actions/records';
import { rowSelected } from '../../actions/inboxTableActions';
import { getLabelsByPage, getLabelsByQuery } from '../../actions/labels';
import { incrementReferralCount, decrementReferralCount } from '../../actions/socket';

class EditPatientDialog extends Component {

  static propTypes = {
    updateEmailAttachmentPatientInfo: PropTypes.func.isRequired,
    updatePatientInfo: PropTypes.func.isRequired,
  }

  render() {
    return (
      <div>
        <EditPatient
          {...this.props}
          edit={this.props.updatePatientInfo}
          sparseEdit={this.props.updateEmailAttachmentPatientInfo}
        />
      </div>
    );
  }
}

export default connect(state => ({
  mode: state.records.mode,
  isLoading: state.records.isLoading,
  allDocumentCategories: state.userProfile.allDocumentCategories,
  sparsePatientUpdate: state.emailAttachmentPatientUpdate,
  data: state.labels.data,
  selectedRecord: state.inboxTable.recordData,
  sendToken: state.records.sendToken,
  updatedLabel: state.records.updatedLabel,
}), {
  getDocumentCategories,
  rowSelected,
  updatePatientInfo,
  updateEmailAttachmentPatientInfo,
  reportSparseUpdateError: reportEmailAttachmentPatientUpdateError,
  updateSelectedRecordLabels,
  getLabelsByPage,
  getLabelsByQuery,
  incrementReferralCount,
  editReceivedRecordLabels,
  decrementReferralCount,
})(EditPatientDialog);
